export const bioData = [
    {
        'title': 'Rupert Adams',
        'bio': [
        "Current Data/Infrastructure Engineer. Previous Thespian. Radical Egalitarian and Tinkerer. If I had to describe myself in four words it would be: 'Does not speak Spanish'. Currently working for Alpega TMS. I am always open for a chat and my favourite colour is none of your business.",
        ""
        ]
    }
]